<template>
  <div class="flex flex-col w-full h-full relative" style="position: relative">
    <div
      class="flex !grow-0 !shrink-0 items-center gap-4 pa-2 w-full bg-gray-200"
      style="font-weight: bold; overflow: auto"
    >
      <div class="cursor-pointer flex items-center gap-2" @click="showFormationTab()">
        <v-icon>mdi-vector-circle</v-icon>
        <span :class="{ selectedTab: isFormationTabVisible }">{{ $t('Fleet.FormationConfig') }}</span>
      </div>
      |
      <div class="cursor-pointer flex items-center gap-2" @click="showDeadZoneTab()">
        <v-icon>mdi-texture-box</v-icon>
        <span :class="{ selectedTab: isDeadZoneTabVisible }">{{ $t('Fleet.DeadZoneConfig') }}</span>
      </div>
    </div>
    <template v-if="isFormationTabVisible">
      <div class="grow-0 !mx-4" v-if="config">
        <h3>{{ $t('Fleet.FormationConfig') }}</h3>
        <div class="flex items-center gap-4">
          <div style="width: 190px; height: 20px" class="pb-4 !grow-0 flex justify-end shrink-0">
            {{ $t('Simulation.NbGlider') }} :
          </div>
          <div class="text-[17px] flex items-center gap-2 !grow-0 shrink-0">
            <div
              @click="removeGlider()"
              small
              class="!grow-0 px-2 cursor-pointer text-white bg-primary text-center rounded h-6 w-7 flex items-center justify-center"
            >
              -
            </div>
            {{ config.glider_number }}
            <div
              @click="addGlider()"
              small
              class="!grow-0 px-2 cursor-pointer text-white bg-primary text-center rounded h-6 w-7 flex items-center justify-center"
            >
              +
            </div>
          </div>
        </div>
        <div class="flex items-center gap-4">
          <div style="width: 190px; height: 20px" class="pb-4 !grow-0 flex justify-end shrink-0">
            {{ $t('Simulation.Formation') }} :
          </div>
          <div class="flex items-center justify-start gap-4 !grow-0">
            <label class="flex items-center gap-2 mr-auto">
              {{ $t('Simulation.Circle') }}
              <input v-model.number="param.ratio_ellipse" type="radio" :value="1" name="ratio_ellipse" />
            </label>
            <label class="flex items-center gap-2">
              {{ $t('Simulation.Comb') }}
              <input v-model.number="param.ratio_ellipse" type="radio" :value="0" name="ratio_ellipse" />
            </label>
          </div>
        </div>
        <div class="flex items-center gap-4">
          <div style="width: 190px; height: 20px" class="pb-4 !grow-0 flex justify-end shrink-0">
            {{ $t('Simulation.Rotation') }} :
          </div>
          <div class="flex items-center grow">
            <span class="w-10">{{ param.rotation }}°</span>
            <v-slider
              color="transparent"
              thumb-color="secondary"
              class="mx-2 my-0"
              hide-details
              ref="slider"
              thumb-label
              thumb-size="32"
              v-model="param.rotation"
              :min="-180"
              :max="180"
              :step="1"
            ></v-slider>
          </div>
        </div>
        <!-- <div  class="flex items-center gap-4">
            <div style="width:190px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.RotationEllipse') }} : </div>                
            <div class="flex items-center"><span class="w-10">{{ param.rotation_ellipse }}°</span><v-slider color="transparent"  thumb-color="secondary" class="mx-2 my-0" hide-details ref="slider"  thumb-label thumb-size="32" v-model="param.rotation_ellipse" :min="-180" :max="180" :step="1" ></v-slider></div>     
        </div>     -->
        <div class="flex items-center gap-4">
          <div style="width: 190px; height: 20px" class="pb-4 !grow-0 flex justify-end shrink-0">
            {{ $t('Simulation.Distance') }} :
          </div>
          <number-field-factor
            v-model.number="param.distance"
            :label="$t('Simulation.Distance')"
            hide-details
            :min="0.01"
          />
        </div>
      </div>
      <div class="relative grow h-[400px] w-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="70"
          height="70"
          viewBox="-10 -10 70 70"
          class="absolute top-5 right-5 z-10"
        >
          <circle cx="25" cy="25" r="23" fill="rgba(255, 255, 255, 0.8)" stroke="#555" stroke-width="1" />
          <line x1="25" y1="2" x2="25" y2="48" stroke="#ccc" stroke-width="1" />
          <line x1="2" y1="25" x2="48" y2="25" stroke="#ccc" stroke-width="1" />

          <!-- Aiguille Nord (rouge) -->
          <path d="M25,25 L25,7" stroke="#e74c3c" stroke-width="2" />
          <text x="25" y="-1" fill="#e74c3c" font-weight="bold" text-anchor="middle" font-family="Arial" font-size="12">
            N
          </text>

          <!-- Aiguille Sud (grise) -->

          <text x="25" y="58" fill="#2c3e50" text-anchor="middle" font-family="Arial" font-size="10">S</text>

          <!-- Est et Ouest -->
          <text x="54" y="28" fill="#2c3e50" text-anchor="middle" font-family="Arial" font-size="10">E</text>
          <text x="-5" y="28" fill="#2c3e50" text-anchor="middle" font-family="Arial" font-size="10">O</text>

          <!-- Point central -->
          <circle cx="25" cy="25" r="3" fill="#34495e" />
        </svg>
        <canvas ref="drawArea" class="w-full h-full"></canvas>
      </div>
    </template>
    <template v-else class="mx-2">
      <div class="grow-0 !mx-4" v-if="config">
        <h3>{{ $t('Fleet.DeadZoneConfig') }}</h3>
        <div class="grid grid-cols-4 gap-4 mt-2">
          <div @mouseover="deadzoneFormationVisible = true" @mouseleave="deadzoneFormationVisible = false">
            <number-field-factor
              v-model.number="config.deadzone_formation"
              hide-details
              :min="0.01"
              :max="config.deadzone_alarm - 0.01"
              :step="0.01"
              :label="$t('Fleet.DzFormation')"
            />
          </div>
          <div @mouseover="deadzoneAreaVisible = true" @mouseleave="deadzoneAreaVisible = false">
            <number-field-factor
              v-model.number="config.deadzone_alarm"
              hide-details
              :min="config.deadzone_formation + 0.01"
              :step="0.01"
              :label="$t('Fleet.DzAlarm')"
            />
          </div>
          <number-field-factor
            v-model.number="config.deadzone_cycle"
            hide-details
            :min="0.01"
            :label="$t('Fleet.DzCycle')"
          />
          <div @mouseover="deadzoneTrackFollowVisible = true" @mouseleave="deadzoneTrackFollowVisible = false">
            <number-field-factor
              v-model.number="config.deadzone_trackFollow"
              hide-details
              :min="0.01"
              :step="0.01"
              :label="$t('Fleet.DzTrackfollow')"
            />
          </div>
        </div>
      </div>
      <div class="!flex flex-col items-center justify-center py-4">
        <span>{{ $t('Fleet.FormationDirection') }}</span>
        <v-icon>mdi-arrow-right-bold-outline</v-icon>
      </div>
      <div ref="deadzoneArea" class="relative grow h-[400px] w-full bg-red-500 !flex items-center justify-center">
        <div class="absolute bg-orange-400" :style="{ width: orangeWidth + 'px', height: orangeHeight + 'px' }"></div>
        <div
          class="absolute bg-green-600 !flex items-center justify-center"
          :style="{ width: greenWidth + 'px', height: orangeHeight + 'px' }"
        >
          <div v-if="deadzoneFormationVisible" class="absolute bg-green-300 !flex items-center w-1/2 h-full left-1/2">
            <div class="w-full h-[1px] bg-black relative !flex items-center">
              <v-icon class="absolute -left-[10px] h-[6px]">mdi-menu-left</v-icon>
              <v-icon class="absolute -right-[10px] h-[6px]">mdi-menu-right</v-icon>
            </div>
          </div>
          <div
            v-if="deadzoneTrackFollowVisible"
            class="absolute bg-green-300 !flex flex-col items-center w-full h-1/2 left-0 top-0"
          >
            <div class="w-[1px] h-full bg-black relative !flex items-center justify-center">
              <v-icon class="absolute top-0 h-[6px]">mdi-menu-up</v-icon>
              <v-icon class="absolute bottom-0 h-[6px]">mdi-menu-down</v-icon>
            </div>
          </div>
          <div
            v-if="deadzoneAreaVisible"
            class="absolute bg-orange-300/90 !flex items-center"
            :style="{
              width: orangeWidth / 2 + 'px',
              height: orangeHeight + 'px',
              left: greenWidth / 2 + 'px',
            }"
          >
            <div class="w-full h-[1px] bg-black relative !flex items-center">
              <v-icon class="absolute -left-[10px] h-[6px]">mdi-menu-left</v-icon>
              <v-icon class="absolute -right-[10px] h-[6px]">mdi-menu-right</v-icon>
            </div>
          </div>
          <v-icon size="16" color="white">mdi-close</v-icon>
        </div>
        <div class="absolute bottom-4 right-4 flex flex-col items-center">
          <span>{{ scaleFac }} km</span>
          <div
            class="h-[6px] border-l border-r border-b border-black"
            :style="{ width: scaleWidth * scaleFac + 'px' }"
          ></div>
        </div>
      </div>
    </template>
    <v-dialog v-model="showRemoveGlider" max-width="950" scrollable>
      <v-card>
        <v-toolbar card>
          <v-toolbar-title>{{ $t('Fleet.GliderRemoveTitle') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div class="font-bold !mb-4">{{ $t('Fleet.ChooseGliderRemove') }}</div>
          <div
            v-for="association in associations"
            class="flex hover:bg-gray-200 items-center justify-between border-t border-gray-200 pl-2"
            :key="association.key"
          >
            <span>{{ association.key }} - {{ association.gliKey }} ({{ association.misId }})</span>
            <v-btn icon @click.prevent="removeAssociation(association)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showRemoveGlider = false" small>{{ $t('Admin.MissionPlanTemplate.Form.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet, AloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import { windows } from '@hscmap/vue-window/lib/types'
import fleet from '@/api/fleet'
import { AloMission } from '@/models/alo/AloMission'

const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleetFormation)

const param = computed(() => modified.value.param)
const config = computed(() => modified.value.config)
const drawArea = ref<HTMLCanvasElement | null>(null)

const deadzoneArea = ref<HTMLDivElement | null>(null)

const leftPanelWidth = computed(() => store.myGetters.currentDetailFleet)

const visibleTab = ref('formation') // formation || deadzone
const isFormationTabVisible = computed(() => visibleTab.value === 'formation')
const isDeadZoneTabVisible = computed(() => visibleTab.value === 'deadzone')

const greenWidth = ref(0)
const orangeWidth = ref(0)
const orangeHeight = ref(0)
const scaleWidth = ref(0)
const scaleFac = ref(1)

const deadzoneAreaVisible = ref(false)
const deadzoneFormationVisible = ref(false)
const deadzoneTrackFollowVisible = ref(false)
const showRemoveGlider = ref(false)

const associations = computed(() =>
  Object.keys(modified.value.config.glider_association).map(key => {
    const asso = modified.value.config.glider_association[key]
    const gliderKey = asso.at(0) as string | null
    const misId = store.myGetters.missions.find(m => m.gliKey?.trim() == gliderKey?.trim() && m.misIdx == asso.at(1))
      ?.misId as number | null
    return {
      key,
      gliKey: gliderKey?.trim() ?? null,
      misId: misId ?? null,
      offsets: asso?.at(2) as [number, number] | undefined,
    }
  }),
)

function showFormationTab() {
  visibleTab.value = 'formation'
}

function showDeadZoneTab() {
  visibleTab.value = 'deadzone'
}

// Function to draw the ellipse and points
const drawEllipseWithPoints = () => {
  if (!drawArea.value) return

  const canvas = drawArea.value
  const ctx = canvas.getContext('2d')
  if (!ctx) return

  // Set canvas dimensions to match its display size
  canvas.width = canvas.clientWidth
  canvas.height = canvas.clientHeight

  // Clear the canvas
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  // Define the point radius and add a margin for the points
  const pointRadius = 12
  const pointMargin = pointRadius + 5 // Additional margin to ensure points are fully visible

  // Calculate the dimensions to fit inside the canvas
  // Add additional padding for the points to ensure they're not cut off
  const padding = pointMargin * 2
  const maxWidth = canvas.width - padding * 2
  const maxHeight = canvas.height - padding * 2

  // Center of the canvas
  const centerX = canvas.width / 2
  const centerY = canvas.height / 2

  const ratio = param.value.ratio_ellipse !== undefined ? param.value.ratio_ellipse : 0
  const numPoints = config.value?.glider_number || 1
  const desiredDistance = param.value.distance || 10
  const rotation = ((param.value.rotation || 0) * Math.PI) / 180

  // Formation en peigne (ligne droite)
  if (ratio === 0) {
    // Ligne droite: longueur = (nombre de points - 1) * distance entre les points
    const lineLength = (numPoints - 1) * desiredDistance

    // Calculer la rotation
    const cosRotation = Math.cos(rotation)
    const sinRotation = Math.sin(rotation)

    // Calculer la longueur maximale de la ligne qui tiendra dans le canvas
    let maxLineLength
    if (rotation % Math.PI === 0) {
      // Ligne horizontale (0° ou 180°)
      maxLineLength = maxWidth
    } else if (Math.abs((rotation % Math.PI) - Math.PI / 2) < 0.001) {
      // Ligne verticale (90° ou 270°)
      maxLineLength = maxHeight
    } else {
      // Pour les angles diagonaux
      const canvasHalfWidth = maxWidth / 2
      const canvasHalfHeight = maxHeight / 2

      maxLineLength = 2 * Math.min(canvasHalfWidth / Math.abs(cosRotation), canvasHalfHeight / Math.abs(sinRotation))
    }

    // Facteur d'échelle pour s'adapter au canvas
    let scale = 1
    if (lineLength != 0) {
      if (lineLength < maxLineLength) {
        // Agrandir pour remplir l'espace disponible
        scale = (0.95 * maxLineLength) / lineLength
      } else {
        // Réduire pour s'adapter
        scale = (0.95 * maxLineLength) / lineLength
      }
    }

    const actualLineLength = lineLength * scale
    const actualDistance = desiredDistance * scale

    // Sauvegarder l'état du canvas pour la rotation de la ligne
    ctx.save()
    ctx.translate(centerX, centerY)
    ctx.rotate(rotation)

    // Dessiner la ligne
    ctx.beginPath()
    ctx.strokeStyle = '#3498db'
    ctx.lineWidth = 2

    const startX = -actualLineLength / 2
    const endX = actualLineLength / 2

    ctx.moveTo(startX, 0)
    ctx.lineTo(endX, 0)
    ctx.stroke()

    // Points array pour stocker les coordonnées réelles et les coordonnées à l'écran
    const pointInfos = []

    // Placer les points le long de la ligne
    if (numPoints > 0) {
      for (let i = 0; i < numPoints; i++) {
        const x = startX + i * actualDistance
        const y = 0

        // Dessiner le point (le cercle noir) qui tourne avec la ligne
        ctx.beginPath()
        ctx.arc(x, y, pointRadius, 0, 2 * Math.PI)
        ctx.fillStyle = '#000000'
        ctx.fill()

        // Calculer les coordonnées réelles (sans échelle) en tenant compte de la rotation
        // Transformer les coordonnées de l'axe horizontal vers les coordonnées réelles
        const unscaledX = x / scale
        const unscaledY = 0
        // Appliquer la rotation aux coordonnées réelles
        const rotatedRealX = unscaledX * Math.cos(rotation) - unscaledY * Math.sin(rotation)
        // Inverser le signe de Y pour que les valeurs positives soient vers le haut
        const rotatedRealY = -1 * (unscaledX * Math.sin(rotation) + unscaledY * Math.cos(rotation))

        // Stocker les informations sur le point
        pointInfos.push({
          index: i + 1,
          realX: rotatedRealX,
          realY: rotatedRealY,
          // Coordonnées dans le canvas pour les étiquettes
          canvasX: centerX + x * cosRotation - y * sinRotation,
          canvasY: centerY + x * sinRotation + y * cosRotation,
        })
      }
    }

    // Restaurer l'état du canvas (annule la rotation)
    ctx.restore()

    // Dessiner les labels des points avec leurs offsets
    pointInfos.forEach(point => {
      // Numéro du point
      ctx.fillStyle = '#ffffff'
      ctx.font = '14px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(`G${point.index}`, point.canvasX, point.canvasY)

      // Préparer le texte des coordonnées
      const coordText = `(${point.realX.toFixed(2)}, ${point.realY.toFixed(2)})`
      const textWidth = ctx.measureText(coordText).width
      const textHeight = 12

      // Positionner les coordonnées en dessous et centrées par rapport au point
      let textX = point.canvasX
      let textY = point.canvasY + pointRadius + 5

      // Ajustement si trop en bas
      if (textY + textHeight > canvas.height - 5) {
        textY = point.canvasY - pointRadius - textHeight - 5
      }

      // Dessiner un fond blanc semi-transparent pour les coordonnées
      ctx.fillStyle = 'rgba(255, 255, 255, 0.5)'
      const padding = 3
      ctx.fillRect(textX - textWidth / 2 - padding, textY - padding, textWidth + padding * 2, textHeight + padding * 2)

      // Afficher les offsets (x,y) à la position optimisée
      ctx.fillStyle = '#27ae60'
      ctx.font = '12px Arial'
      ctx.textAlign = 'center' // Centré par rapport au point
      ctx.textBaseline = 'top'
      ctx.fillText(coordText, textX, textY)
    })

    AloDbFleet.updateGliderAssociationOffset(
      modified.value,
      pointInfos.map(point => [Number.parseFloat(point.realX.toFixed(2)), Number.parseFloat(point.realY.toFixed(2))]),
    )
  }
  // Formation en cercle
  else if (ratio === 1) {
    // Calculer d'abord le rayon basé sur la distance imposée entre les points
    let radius = desiredDistance // Valeur par défaut

    if (numPoints > 1) {
      const angle = (2 * Math.PI) / numPoints
      radius = desiredDistance / (2 * Math.sin(angle / 2))
    }

    // Déterminer le rayon maximal qui peut tenir dans le canvas
    const maxRadius = (Math.min(maxWidth, maxHeight) / 2) * 0.95

    // Calculer le facteur d'échelle pour zoomer/dézoomer le cercle
    let scaleFactor = 1
    if (radius > 0) {
      scaleFactor = maxRadius / radius
    }

    // Appliquer le facteur d'échelle pour l'affichage
    const displayRadius = radius * scaleFactor

    // Dessiner le cercle
    ctx.save()
    ctx.translate(centerX, centerY)

    ctx.beginPath()
    ctx.strokeStyle = '#3498db'
    ctx.lineWidth = 2
    ctx.arc(0, 0, displayRadius, 0, 2 * Math.PI)
    ctx.stroke()

    // Dessiner les axes du cercle
    ctx.beginPath()
    ctx.strokeStyle = '#2ecc71'
    ctx.lineWidth = 1
    ctx.setLineDash([5, 3])

    ctx.moveTo(-displayRadius, 0)
    ctx.lineTo(displayRadius, 0)
    ctx.moveTo(0, -displayRadius)
    ctx.lineTo(0, displayRadius)

    ctx.stroke()
    ctx.setLineDash([])

    // Afficher le rayon calculé à droite du centre du cercle, légèrement au-dessus de l'axe
    ctx.fillStyle = '#2980b9'
    ctx.font = '12px Arial'
    ctx.textAlign = 'left'
    ctx.textBaseline = 'bottom'
    ctx.fillText(`Rayon: ${radius.toFixed(2)} km`, displayRadius * 0.3, -10) // Positionné à 30% du rayon vers la droite, légèrement au-dessus de l'axe

    // Placer les points autour du cercle et stocker leurs coordonnées
    const pointInfos = []

    if (numPoints > 0) {
      for (let i = 0; i < numPoints; i++) {
        // Calculer l'angle pour ce point
        const angleOffset = rotation - Math.PI / 2 // Décalage pour que le point 1 soit en haut
        const angle = (i * 2 * Math.PI) / numPoints + angleOffset

        const x = displayRadius * Math.cos(angle)
        const y = displayRadius * Math.sin(angle)
        // Coordonnées réelles (sans échelle)
        const realX = radius * Math.cos(angle)
        // Inverser le signe de Y pour que les valeurs positives soient vers le haut
        const realY = -1 * (radius * Math.sin(angle))

        // Dessiner le point
        ctx.beginPath()
        ctx.arc(x, y, pointRadius, 0, 2 * Math.PI)
        ctx.fillStyle = '#000000'
        ctx.fill()

        // Numéro du point
        ctx.fillStyle = '#ffffff'
        ctx.font = '14px Arial'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(`G${(i + 1).toString()}`, x, y)

        // Stocker les infos du point
        pointInfos.push({
          canvasX: x,
          canvasY: y,
          realX,
          realY,
        })
      }

      // Tracer des lignes grises en pointillé reliant les points successifs
      ctx.beginPath()
      ctx.strokeStyle = '#95a5a6' // Gris
      ctx.lineWidth = 1
      ctx.setLineDash([3, 3]) // Pointillés

      for (let i = 0; i < pointInfos.length; i++) {
        const currentPoint = pointInfos[i]
        const nextPoint = pointInfos[(i + 1) % pointInfos.length] // Utilise modulo pour revenir au premier point

        ctx.moveTo(currentPoint.canvasX, currentPoint.canvasY)
        ctx.lineTo(nextPoint.canvasX, nextPoint.canvasY)
      }

      ctx.stroke()
      ctx.setLineDash([]) // Réinitialiser le style de ligne

      // Dessiner les points
      pointInfos.forEach((point, i) => {
        // Dessiner le point
        ctx.beginPath()
        ctx.arc(point.canvasX, point.canvasY, pointRadius, 0, 2 * Math.PI)
        ctx.fillStyle = '#000000'
        ctx.fill()

        // Numéro du point
        ctx.fillStyle = '#ffffff'
        ctx.font = '14px Arial'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(`G${(i + 1).toString()}`, point.canvasX, point.canvasY)
      })
    }

    // Afficher les offsets (x,y) à côté des points
    pointInfos.forEach((point, i) => {
      // Préparer le texte des coordonnées
      const coordText = `(${point.realX.toFixed(2)}, ${point.realY.toFixed(2)})`
      const textWidth = ctx.measureText(coordText).width
      const textHeight = 12

      // Positionner les coordonnées en dessous et centrées par rapport au point
      let textX = point.canvasX
      let textY = point.canvasY + pointRadius + 5

      // Ajustement si trop bas (sortie du cercle)
      if (textY + textHeight > displayRadius * 0.9) {
        textY = point.canvasY - pointRadius - textHeight - 5
      }

      // Dessiner un fond blanc semi-transparent pour les coordonnées
      ctx.fillStyle = 'rgba(255, 255, 255, 0.5)'
      const padding = 3
      ctx.fillRect(textX - textWidth / 2 - padding, textY - padding, textWidth + padding * 2, textHeight + padding * 2)

      // Afficher les coordonnées
      ctx.fillStyle = '#27ae60'
      ctx.font = '12px Arial'
      ctx.textAlign = 'center' // Centré par rapport au point
      ctx.textBaseline = 'top'
      ctx.fillText(coordText, textX, textY)
    })

    ctx.restore()

    AloDbFleet.updateGliderAssociationOffset(
      modified.value,
      pointInfos.map(point => [Number.parseFloat(point.realX.toFixed(2)), Number.parseFloat(point.realY.toFixed(2))]),
    )
  }
}

function removeGlider() {
  if (config.value?.glider_number > 1) {
    if (modified.value.param.start_date) {
      showRemoveGlider.value = true
    } else {
      config.value.glider_number--
      AloDbFleet.correctGliderAssociation(modified.value)
    }
  }
}
function addGlider() {
  config.value.glider_number++
  AloDbFleet.correctGliderAssociation(modified.value)
}

function removeAssociation(asso: {
  key: string
  gliKey: string | null
  misId: number | null
  offsets: [number, number] | undefined
}) {
  let idx = 0
  modified.value.config.glider_association = Object.keys(modified.value.config.glider_association).reduce(
    (acc, key) => {
      if (key != asso.key) acc[`GLIDER${++idx}`] = modified.value.config.glider_association[key]
      return acc
    },
    {} as Record<string, [string | null, number | null, [number, number]]>,
  )
  modified.value.param.associationIds = modified.value.param.associationIds.filter(id => id !== asso.misId)
  config.value.glider_number = idx
  AloDbFleet.correctGliderAssociation(modified.value)
  showRemoveGlider.value = false
}

function drawDeadZone() {
  // if (!drawArea.value) return
  // const canvas = drawArea.value
  // const ctx = canvas.getContext('2d')
  // if (!ctx) return
  // // Set canvas dimensions to match its display size
  // canvas.width = canvas.clientWidth
  // canvas.height = canvas.clientHeight
  // // Clear the canvas
  // ctx.clearRect(0, 0, canvas.width, canvas.height)
  if (!deadzoneArea.value) return
  const div = deadzoneArea.value
  const dw = div.clientWidth * 0.9
  const dh = div.clientHeight * 0.9

  const d = Math.min(dw, dh)

  const refW = Math.max(
    config.value?.deadzone_trackFollow ?? 0,
    config.value?.deadzone_alarm ?? 0,
    config.value?.deadzone_formation ?? 0,
  )

  const scale = refW > 0 ? d / refW : 1

  greenWidth.value = (config.value?.deadzone_formation ?? 0) * scale
  orangeWidth.value = (config.value?.deadzone_alarm ?? 0) * scale
  orangeHeight.value = (config.value?.deadzone_trackFollow ?? 0) * scale
  scaleWidth.value = scale / 2
  scaleFac.value = Math.ceil(100 / scaleWidth.value)
}

function drawMode() {
  if (isFormationTabVisible.value) drawEllipseWithPoints()
  else drawDeadZone()
}

// Watch for changes to redraw
watch(
  () => [
    config.value?.deadzone_alarm,
    config.value?.deadzone_formation,
    config.value?.deadzone_trackFollow,
    param.value.ratio_ellipse,
    param.value.rotation,
    config.value?.glider_number,
    param.value.distance,
    leftPanelWidth.value,
    isFormationTabVisible.value,
  ],
  () => {
    nextTick(() => {
      drawMode()
    })
  },
  { deep: true },
)

function test() {
  alert('test')
}

// Redraw on window resize
onMounted(() => {
  setTimeout(drawMode, 500)

  window.addEventListener('resize', drawMode)

  // Clean up event listener when component is unmounted
  return () => {
    window.removeEventListener('resize', drawMode)
  }
})

defineExpose({
  drawMode,
})
</script>
